import { render } from "./Inpcont.vue?vue&type=template&id=1077c8c0&scoped=true"
import script from "./Inpcont.vue?vue&type=script&lang=js"
export * from "./Inpcont.vue?vue&type=script&lang=js"

import "./Inpcont.vue?vue&type=style&index=0&id=1077c8c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1077c8c0"

export default script